import {
  GET_MORE_ONLINE_FEEDS,
  SET_ONLINE_FEEDS_FAILED,
  SET_ONLINE_FEEDS_START,
  SET_ONLINE_FEEDS_FINISH,
} from "../actions/actionTypes";

import { MAX_FEEDS_LIMIT } from "../constants/app-constant";

const initialState = {
  onlineNewsFeeds: {
    isLoading: true,
    error: undefined,
    data: [],
    showMore: false,
  },
};

export const onlineFeedsReducer = (
  state = initialState,
  { type, data, error }
) => {
  switch (type) {
    case GET_MORE_ONLINE_FEEDS:
      return {
        ...state,
        ...{
          onlineNewsFeeds: {
            isLoading: true,
            data: state.onlineNewsFeeds.data,
          },
        },
      };

    case SET_ONLINE_FEEDS_START:
      return {
        ...state,
        ...{
          onlineNewsFeeds: {
            isLoading: true,
            data: [],
          },
        },
      };

    case SET_ONLINE_FEEDS_FINISH: {
      return {
        ...state,
        onlineNewsFeeds: {
          isLoading: false,
          data: [...state.onlineNewsFeeds.data, ...data],
          showMore: data.length >= MAX_FEEDS_LIMIT,
        },
      };
    }

    case SET_ONLINE_FEEDS_FAILED:
      return {
        ...state,
        onlineNewsFeeds: {
          isLoading: false,
          error,
          data: [],
          showMore: false,
        },
      };
    default:
      return state;
  }
};
